import React, { useEffect, useState } from "react";
import { Header } from "../components/Header";
import { Ticker } from "../components/Ticker";
import { NewsSection } from "../components/NewsSection";
import { Footer } from "../components/Footer";
import { getNews } from "../lib/api";

export default function NewsPage() {
  const [tickerItems, setTickerItems] = useState([]);

  useEffect(() => {
    getNews("all")
      .then((d) => setTickerItems((d || []).slice(0, 10)))
      .catch(() => setTickerItems([]));
  }, []);

  return (
    <div className="min-h-screen bg-[var(--page-bg)] text-[var(--brand-ink)]" data-testid="page-news">
      <Header />
      <Ticker items={tickerItems} />
      <NewsSection />
      <Footer />
    </div>
  );
}
